import React, { useRef, useState } from 'react'

import Buttons from '../../../components/ui/button/Buttons';
import FormCreator from '../../../components/finalForms/FormCreator';

import { multiRowFormConfig } from './config/multiRowFormConfig.data';

const MultiRowFormPage = () => {

    const userRef = useRef();
    const [userForm] = useState(multiRowFormConfig);

    const handleSave = () => {
        const formData = userRef.current.getFormData();

        if (formData) {
            // //console.log(formData);
        }
    }

    return (
        <>
            <div className='page-title'>
                <h3>Multi Row Form Creator</h3>
            </div>
            <div className='row multi-row-form-page'>
                <FormCreator
                    config={userForm}
                    ref={userRef}
                    key={false}
                />
            </div>
            <Buttons
                isLoading={false}
                textWithIcon={false}
                buttonText='Save'
                titleText="Save"
                buttonTypeClassName={'btn theme-btn'}
                onClick={handleSave}
            />
        </>
    )
}

export default MultiRowFormPage